import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const handleSendMail = () => {
    const email = 'gladiousconstruction@gmail.com';
    const subject = encodeURIComponent('Hello from Gladious');
    const body = encodeURIComponent('I would like to contact you regarding...');

    if (isMobile) {
      // 📱 Mobile: use mailto (opens email app or Gmail)
      const mailtoUrl = `mailto:${email}?subject=${subject}&body=${body}`;
      window.location.href = mailtoUrl;
    } else {
      // 💻 Desktop: open Gmail compose in new tab
      const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`;
      window.open(gmailUrl, '_blank');
    }
  };

  return (
    <div className="contact-hero-section">
      <div className="contact-hero-content">
        <h1 className="contact-hero-title">Gladious Constructions</h1>
        <p className="contact-hero-text">
          Building excellence, constructing trust. Your premier construction partner for all your building needs.
        </p>
        <div className="contact-hero-buttons">
          {/* Call Button */}
          <a href="tel:03286506281" className="btn btn-primary">
            Call us
          </a>

          {/* Send Mail Button */}
          <button className="btn btn-outline" onClick={handleSendMail}>
            Send Mail
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
